import { render, staticRenderFns } from "./FamilyObliteration.vue?vue&type=template&id=01415651&scoped=true"
import script from "./FamilyObliteration.vue?vue&type=script&lang=js"
export * from "./FamilyObliteration.vue?vue&type=script&lang=js"
import style0 from "./FamilyObliteration.vue?vue&type=style&index=0&id=01415651&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01415651",
  null
  
)

export default component.exports